import { URLS } from '@/constants';
import { AttachedPackagesResponse, AttachPackageRequest } from '@/services/api/models/traceability';
import session from '@/services/session';

/**
 * Fetch LeafLink orders associated with a Metrc Package
 * @param {string} packageLabel - label of package which we want to fetch orders for
 */

export const getPackageOrders = (packageLabel) => {
  const url = URLS.S2S.PACKAGE_ORDERS.replace('%label%', packageLabel);
  const params = { error_format: 'jsonapi' };

  return session.get(url, { params }).then((response) => response.data);
};

export const removeAttachedPackage = async (id: number) => {
  const params = { error_format: 'jsonapi' };
  const response = await session.delete<void>(`${URLS.S2S.ATTACHED_PACKAGES}/${id}/`, { params });

  return response.data;
};

export const attachPackage = async (data: AttachPackageRequest) => {
  const params = { error_format: 'jsonapi' };
  const response = await session.post<AttachedPackagesResponse>(`${URLS.S2S.ATTACHED_PACKAGES}/`, data, { params });

  return response.data;
};
